import image1 from '../../../assets/images/faces/1.jpg';
import face12 from '../../../assets/images/faces/12.jpg';
import face9 from '../../../assets/images/faces/9.jpg';
import face4 from '../../../assets/images/faces/4.jpg';
import face15 from '../../../assets/images/faces/15.jpg';
import face5 from '../../../assets/images/faces/5.jpg'

//User Today Tasks
export const Todotaskdata1 = [
    { id: 1, profileImage: image1, title: 'Work Assigned by Clients ,try to get new work',badgeclr:"bg-purple",badgenum:9, description: 'Sed ut perspiciatis unde omnis iste natus' },
    { id: 2, profileImage: face12, title: 'voluptatem accusantium dolo laudantium',badgeclr:"bg-info",badgenum:2, description: 'voluptatem accusantium dolo laudantium' },
    { id: 3, profileImage: face9, title: 'Nemo enim ipsam voluptatem quia voluptas',badgeclr:"bg-danger",badgenum:6, description: 'vero eos et accusamus et iusto odio dignissimos' },
    { id: 4, profileImage: face4, title: 'Ut enim ad minima veniam nostrum exercitationem',badgeclr:"bg-info",badgenum:9, description: 'Quis autem vel eum iure reprehenderit qui' },
    { id: 5, profileImage: face15, title: 'I must explain to you how all this mistaken',badgeclr:"bg-primary",badgenum:7, description: 'I will give you a complete account of the system' },
    { id: 6, profileImage: face5, title: 'Rationally encounter quences extremely painful',badgeclr:"bg-info",badgenum:4, description: 'Which of us ever undertakes laborious physical' },
]
//Tasks
export const Todotaskdata2 = [
    { id: 1, task: "Today Tasks", bgColor: "bg-info" },
    { id: 2, task: "Yesterday Tasks", bgColor: "bg-primary" },
    { id: 3, task: "Weakly Tasks", bgColor: "bg-success" },
    { id: 4, task: "Mothly Tasks", bgColor: "bg-danger" },
    { id: 5, task: "User Tasks", bgColor: "bg-warning" },
]
//Recent Tasks
export const Todotaskdata3 = [
    { id: 1, title: "Do something more", cheacked: true },
    { id: 2, title: "Update More More Files", cheacked: true },
    { id: 3, title: "Complete Projects", cheacked: false },
    { id: 4, title: "Finish Something", cheacked: false },
    { id: 5, title: "System Updated", cheacked: true },
    { id: 6, title: "Change Settings", cheacked: false },
]